import { ServiceRequestStatusEnum } from '../types/serviceRequestStatus';
import { WorkOrderModuleSettings } from 'lane-shared/domains/workOrder';

export function canSubmitSurvey(
  settings: WorkOrderModuleSettings,
  serviceRequestStatus: ServiceRequestStatusEnum
): boolean {
  const surveySubmissionsAvailableStatus = settings.configuration?.workOrderSurveys?.autoSurveyTriggerStatus;
  const isFeedbackAllowed = settings.configuration?.workOrderSurveys?.allowFeedback;

  if (!surveySubmissionsAvailableStatus || !isFeedbackAllowed) {
    return false;
  }

  return serviceRequestStatus === surveySubmissionsAvailableStatus;
}

export const useSurveySubmissionEligibility = (
  settings: WorkOrderModuleSettings,
  serviceRequestStatus: ServiceRequestStatusEnum | undefined
): { isSurveySubmissionEligible: boolean } => {
  if (!serviceRequestStatus) {
    return {
      isSurveySubmissionEligible: false,
    };
  }

  return {
    isSurveySubmissionEligible: canSubmitSurvey(settings, serviceRequestStatus),
  };
};
